module.exports = __webpack_public_path__ + "static/media/reload.9bd0c8d6.svg";